import React from "react";
import NavButton from "./NavButton";
import { PiTree } from "react-icons/pi";
import { PiTreeFill } from "react-icons/pi";

interface GrowButtonProps {
  isActive: boolean;
  onClick: () => void;
}

const GrowButton: React.FC<GrowButtonProps> = ({ isActive, onClick }) => {
  return (
    <NavButton
      isActive={isActive}
      onClick={onClick}
      icon={<PiTree className="h-full w-auto" />}
      fillIcon={<PiTreeFill className="h-full w-auto" />}
      text="Grow"
    />
  );
};

export default GrowButton;
